module.exports = __webpack_public_path__ + "static/media/w3.ee4c2375.jpg";